import React, { useState } from "react";
import { PiMagnifyingGlass } from "react-icons/pi";
import { TbList } from "react-icons/tb";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { MdOutlineChecklist } from "react-icons/md";
import { useLanguage } from "../../Translations/LenguageContext";
import MandatorySign from "../../Components/MandatorySign";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const CustomSource = ({
    account_id,
    org_id,
    context_id,
    fetchRecords,
    closeModal,
    handleBack
}) => {
    const { t } = useLanguage()
    const [loadingExtract, setLoadingExtract] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        message: "",
        display: false,
    });

    const [formData, setFormData] = useState({
        title: "",
        text: "",
    })

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const setCustomSource = async () => {
        if (!formData.title) {
            setErrorMessage({
                message: t.context.title_required,
                display: true,
            });
            return;
        }

        if (!formData.text) {
            setErrorMessage({
                message: t.context.text_required,
                display: true,
            });
            return;
        }

        setLoadingExtract(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/create_custom_source`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    context_id,
                    title: formData.title,
                    text: formData.text,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message === "OK") {
                closeModal()
                fetchRecords()
            }
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true,
            });
        } finally {
            setLoadingExtract(false);
        }
    }


    return (
        <div className="source_cont">
            <div className="custom_source_cont">
                <div className="label_input">
                    <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                    <input
                        type="text"
                        name="title"
                        maxLength={100}
                        value={formData.title}
                        onChange={handleChange}
                        placeholder={t.context.title_placeholder}
                        className="register_form_first fade-in"
                        autoComplete="off"
                    />
                </div>
                <div className="label_input">
                    <label className="input_label">{t.context.text} <MandatorySign message={t.mandatory_field} /></label>
                    <textarea
                        type="text"
                        name="text"
                        value={formData.text}
                        onChange={handleChange}
                        placeholder={t.context.description_placeholder_2}
                        className="register_form_first textarea_reg fade-in"
                        autoComplete="off"
                    />
                </div>
            </div>

            {errorMessage.display && (
                <ErrorMessage err={errorMessage} />
            )}

            {(formData.title && formData.text) && (
                <button className="source_run_btn fade-in" onClick={setCustomSource}>
                    {loadingExtract ? <Spinner loading={loadingExtract} /> : t.context.set_custom_context}
                </button>
            )}
        </div>
    );
};

export default CustomSource;
